import { memo } from 'react';
import { Box, Icon } from '@nimbus-ds/components';
import { PlayIcon } from '@nimbus-ds/icons';
import { useResponsive } from 'commons/components';
import './VideoThumbnail.scss';

type VideoThumbnailProps = {
  src: string;
  alt: string;
  onClick: () => void;
};

export const VideoThumbnail = memo<VideoThumbnailProps>(
  ({ src, alt, onClick }) => {
    const { isMobile } = useResponsive();
    const width = isMobile ? 68 : 188;
    const height = isMobile ? 68 : 48;
    const fullClassName = 'stratus--video-thumbnail';
    const paddingRight = '3';

    return (
      <button
        type="button"
        className={`${fullClassName}__container`}
        onClick={onClick}
        aria-label={alt}
      >
        <Box
          position="relative"
          width={`${width}px`}
          height={`${height}px`}
          overflow="hidden"
          paddingRight={paddingRight}
          className={`${fullClassName}__frame`}
        >
          <Box position="relative" width="100%" height="100%">
            <img src={src} alt={alt} className={`${fullClassName}__image`} />
            <Box
              position="absolute"
              top="0"
              left="0"
              right="0"
              bottom="0"
              display="flex"
              alignItems="center"
              justifyContent="center"
              className={`${fullClassName}__overlay`}
            >
              <Icon
                source={<PlayIcon size="medium" />}
                color="neutral-background"
              />
            </Box>
          </Box>
        </Box>
      </button>
    );
  },
);

VideoThumbnail.displayName = 'VideoThumbnail';
